import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from '../pages/auth/login/login.component';
import { ForgotPasswordStep1Component } from '../pages/auth/forgot-password/forgotPassword1.component';
import { ForgotPasswordStep2Component } from '../pages/auth/forgot-password/forgotPassword2.component';
import { LogoutComponent } from '../pages/auth/logout.component';
import { SupportComponent } from '../pages/support/support';
import { UserProfilePage } from '../pages/user-profile/user-profile';
import { ChooseActiveProjectPage } from '../components/choose-active-project/choose-active-project';
import { ProjectHomePage } from '../pages/project-home/project-home';
import { CompanyPage } from '../pages/company/company';
import { CompanyInfoTab } from '../pages/company-info-tab/company-info-tab';
import { LogView } from '../pages/log-view/log-view';
import { AddProjectUserComponent } from '../pages/add-project-user/add-project-user';
import { NewUpdateComponent } from '../pages/new-update/new-update';
import { ArchivedUpdates } from '../pages/archived-updates/archived-updates';
import { NewLogComponent } from '../pages/new-log/new-log';
import { ActivityLogsPage } from '../pages/activity-logs/activity-logs';
import { ActivityListPage } from '../pages/activities/activities';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },  // The 'landing' page, if there is no tail in the URL
  { path: 'login', component: LoginComponent, data: { title: 'Login' } },
  { path: 'resetPW', component: ForgotPasswordStep1Component },
  { path: 'createPW', component: ForgotPasswordStep2Component, data: { title: 'Create Password' } },
  { path: 'ProjectHomePage', component: ProjectHomePage, data: { title: 'Project Home' } }, 
  { path: ':CompanyName/details', component: CompanyPage, data: { title: 'Company Details' } },
  { path: ':CompanyName/members', component: CompanyPage, data: { title: 'Company Members' } },
  { path: ':CompanyName/projects', component: CompanyPage, data: { title: 'Company Projects' } },
  { path: ':CompanyName/editDetails', component: CompanyInfoTab, data: { title: 'Edit Company details' } },
  { path: ':CompanyName/addNewMember', component: CompanyInfoTab, data: { title: 'Add New Member' } },
  { path: ':CompanyName/addNewProject', component: CompanyInfoTab, data: { title: 'Add New Project' } },
  { path: ':ProjectName/activities', component: ActivityListPage, data: { title: 'Activities List' } },
  { path: ':ProjectName/activities/addNewActivityLog', component: NewLogComponent, data: { title: 'Add New Daily Activity Log' } },
  { path: ':ProjectName/logs', component: ActivityLogsPage, data: { title: 'Project Logs' } },
  { path: ':ProjectName/logs/addNewDailyLog', component: NewLogComponent, data: { title: 'Add New Daily Log' } },
  { path: ':ProjectName/updateArchive', component: ArchivedUpdates, data: { title: 'Update Project Archive' } },
  { path: ':ProjectName/noActiveUpdate', component: ProjectHomePage, data: { title: 'No Active Update' } },
  { path: ':ProjectName/noActiveUpdate/setupNewUpdate', component: NewUpdateComponent, data: { title: 'Set Up New Update' } },
  { path: ':ProjectName/noActiveUpdate/addProjectMember', component: AddProjectUserComponent, data: { title: 'Add project Member' } },
  { path: ':ProjectName/:LogID', component: LogView, data: { title: 'Activity details Log' } },  // Matches the URL /projectName/activityLogDetails-LogID
  // dailyLogDetails-LogID  FS: Need to figure out how to get to this modal
  { path: 'editProfile', component: UserProfilePage, data: { title: 'Edit Profile' } },
  { path: 'changeProject', component: ChooseActiveProjectPage, data: { title: 'Change Profile' } },
  { path: 'contactSupport', component: SupportComponent, data: { title: 'Contact Support' } },
  { path: 'logout', component: LogoutComponent },
  { path: '**', redirectTo: '/' } // If the URL doesn't match any of the above
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes,
      { 
        enableTracing: true 
        // useHash: false 
      })  // Debugging; logs to the console
  ],
  exports: [
    RouterModule
  ]
})
export class RoutesModule {
}



// WEBPACK FOOTER //
// ./src/app/routes.module.ts